import Vue from "vue";
import Vuex from "vuex";
import nav from "./moudels/nav.js";
import {
  setToken,
  getToken,
  removeToken,
  clearUserData,
  getUserInfo
} from "../utils/auth";
Vue.use(Vuex);

// 获取用户信息的辅助函数
function getUserData() {
  const userInfo = getUserInfo();
  return {
    token: userInfo.token || "",
    account: userInfo.account || "",
    avatar: userInfo.avatar || "",
    userName: userInfo.userName || "",
    vip: !!userInfo.vip,
    vipName: userInfo.vipName || "",
    vipDate: userInfo.vipDate || "",
    uploadimage: userInfo.uploadimage || "",
    // 新增权限相关字段
    userInfo: userInfo.userInfo || {},
    canFileManage: userInfo.canFileManage || false,
    canUserManage: userInfo.canUserManage || false,
    canSystemManage: userInfo.canSystemManage || false,
    role: userInfo.role || "",
    permissionLevel: userInfo.permissionLevel || 0
  };
}

export default new Vuex.Store({
  state: {
    ...getUserData(),
    openid: localStorage.getItem("openid") ? localStorage.getItem("openid") : "" //token标识
  },
  mutations: {
    token(state, { value, remember }) {
      state.token = value;
      setToken(value, remember);
    },
    openid(state, value) {
      state.openid = value;
      localStorage.setItem("openid", value);
    },
    account(state, { value, remember = false }) {
      state.account = value;
      localStorage.setItem("account", value);
      if (remember) {
        localStorage.setItem("accountExpiry", "persistent");
      } else {
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("accountExpiry", expiryTime.toString());
      }
      sessionStorage.removeItem("account");
    },
    avatar(state, { value, remember = false }) {
      state.avatar = value;
      localStorage.setItem("avatar", value);
      if (remember) {
        localStorage.setItem("avatarExpiry", "persistent");
      } else {
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("avatarExpiry", expiryTime.toString());
      }
      sessionStorage.removeItem("avatar");
    },
    vip(state, { value, remember = false }) {
      // 确保VIP状态为布尔值，处理undefined/null情况
      const vipValue = value === true || value === "true" || value === 1;
      state.vip = vipValue;
      localStorage.setItem("vip", vipValue ? "true" : "false");
      if (remember) {
        localStorage.setItem("vipExpiry", "persistent");
      } else {
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("vipExpiry", expiryTime.toString());
      }
      sessionStorage.removeItem("vip");
    },
    vipName(state, { value, remember = false }) {
      state.vipName = value || "";
      localStorage.setItem("vipName", value || "");
      if (remember) {
        localStorage.setItem("vipNameExpiry", "persistent");
      } else {
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("vipNameExpiry", expiryTime.toString());
      }
      sessionStorage.removeItem("vipName");
    },
    vipDate(state, { value, remember = false }) {
      state.vipDate = value || "";
      localStorage.setItem("vipDate", value || "");
      if (remember) {
        localStorage.setItem("vipDateExpiry", "persistent");
      } else {
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("vipDateExpiry", expiryTime.toString());
      }
      sessionStorage.removeItem("vipDate");
    },
    uploadimage(state, { value, remember = false }) {
      state.uploadimage = value;
      localStorage.setItem("uploadimage", value);
      if (remember) {
        localStorage.setItem("uploadimageExpiry", "persistent");
      } else {
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("uploadimageExpiry", expiryTime.toString());
      }
      sessionStorage.removeItem("uploadimage");
    },
    userName(state, { value, remember = false }) {
      state.userName = value;
      localStorage.setItem("userName", value);
      if (remember) {
        localStorage.setItem("userNameExpiry", "persistent");
      } else {
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("userNameExpiry", expiryTime.toString());
      }
      sessionStorage.removeItem("userName");
    },
    // 重置所有用户状态
    resetUserState(state) {
      state.token = "";
      state.account = "";
      state.avatar = "";
      state.userName = "";
      state.vip = false;
      state.vipName = "";
      state.vipDate = "";
      state.uploadimage = "";
      // 重置权限相关状态
      state.userInfo = {};
      state.canFileManage = false;
      state.canUserManage = false;
      state.canSystemManage = false;
      state.role = "";
      state.permissionLevel = 0;
      // 注意：openid 通常保留，因为它是第三方登录标识，不是用户凭证
      // 如果需要清除 openid，可以在退出登录时单独处理
    }
  },
  actions: {
    // 初始化用户数据
    initUserData(context) {
      const userInfo = getUserInfo();
      if (userInfo.token) {
        // 直接设置state，不调用mutation
        context.state.token = userInfo.token;
        context.state.account = userInfo.account || "";
        context.state.avatar = userInfo.avatar || "";
        context.state.userName = userInfo.userName || "";
        context.state.vip = userInfo.vip || false;
        context.state.vipName = userInfo.vipName || "";
        context.state.vipDate = userInfo.vipDate || "";
        context.state.uploadimage = userInfo.uploadimage || "";
        // 设置权限相关状态
        context.state.userInfo = userInfo.userInfo || {};
        context.state.canFileManage = userInfo.canFileManage || false;
        context.state.canUserManage = userInfo.canUserManage || false;
        context.state.canSystemManage = userInfo.canSystemManage || false;
        context.state.role = userInfo.role || "";
        context.state.permissionLevel = userInfo.permissionLevel || 0;
      }
    },
    token(context, payload) {
      context.commit("token", payload);
    },
    openid(context, value) {
      context.commit("openid", value);
    },
    account(context, payload) {
      context.commit("account", payload);
    },
    avatar(context, payload) {
      context.commit("avatar", payload);
    },
    vip(context, payload) {
      context.commit("vip", payload);
    },
    vipName(context, payload) {
      context.commit("vipName", payload);
    },
    vipDate(context, payload) {
      context.commit("vipDate", payload);
    },
    uploadimage(context, payload) {
      context.commit("uploadimage", payload);
    },
    userName(context, payload) {
      context.commit("userName", payload);
    },
    // 重置用户状态
    resetUserState(context) {
      context.commit("resetUserState");
      clearUserData();
    }
  },
  getters: {},
  modules: {
    nav
  }
});
